import AmpleHireImageTag from "../../ample-hire-html-tags/ample-hire-image-tag";
import { icon } from "../../assets/assets";
import { Link, useLocation } from "react-router-dom";

const routeLabels = {
  "user-management": "Team Members",
  "create-job": "Job Openings",
  "job-details": "Position Details",
  "job-position-details": "Configuration",
  "define-interview": "Interview Setup",
  "add-questions": "Question Library",
  "new-question": "Create New",
  "from-question-bank": "From Library",
  "from-previous-position": "From Template",
  "invite-link": "Send Invites",
  "invite-candidates": "Send Invites",
  "invited-candidates": "Invite Tracker",
  "summary-by-position": "Position Overview",
  "scores-by-interview-round": "Round Scores",
  "candidate-video-answers": "Video Responses",
  "candidate-video-answer-summary": "Response Details",
  "candidates-scores-summary": "Score Dashboard",
  "search-candidates": "Find Candidates",
  "search-interviews": "Find Interviews",
  "shuffle-questions": "Reorder Questions",
  "dashboard": "Dashboard",
  "role": "Roles",
  "feature-tree": "Permissions",
  "industry": "Industries",
  "domain-skill": "Domain Skills",
  "soft-skill": "Soft Skills",
  "location": "Locations",
  "terms-of-use": "Terms of Service",
};

function getLabel(segment) {
  if (routeLabels[segment]) return routeLabels[segment];
  return segment
    ?.split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const BreadCrumb = () => {
  const location = useLocation();

  const segments = location.pathname.split("/").slice(2);
  const breadcrumbValue = segments
    .map(segment => getLabel(segment))
    .join(" / ");

  return (
    <ul className="breadcrumb-wr">
      <li>
        <Link to={`/admin`}>
          <i>
            <AmpleHireImageTag
              className={"margin-right-5"}
              imgSrc={icon.homeIcon}
              altText={"Home"}
            />
          </i>
          Home
        </Link>
      </li>
      <li>{breadcrumbValue}</li>
    </ul>
  );
};

export default BreadCrumb;
